export default __webpack_public_path__ + "bed3f333f98a79006afaa09f2721cd57.svg";